import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "section"
}
const _hoisted_2 = { class: "container is-tp-container" }
const _hoisted_3 = {
  key: 0,
  class: "column is-12 mt-6",
  ref: "loadingApplications"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "Loading Application...", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("progress", {
  class: "progress is-small is-link",
  max: "100"
}, "20%", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "columns is-multiline"
}
const _hoisted_9 = { class: "column is-12" }
const _hoisted_10 = { class: "columns is-vcentered" }
const _hoisted_11 = { class: "column is-narrow" }
const _hoisted_12 = { class: "image is-48x48" }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  class: "black-white",
  "data-test": "application-name"
}
const _hoisted_15 = { class: "column" }
const _hoisted_16 = {
  class: "title is-1",
  "data-test": "text-name"
}
const _hoisted_17 = {
  key: 0,
  class: "column is-narrow"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "create", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  class: "has-text-grey is-size-5 mb-6",
  "data-test": "description"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "columns is-vcentered" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "column" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "title is-4" }, "Basic information")
  ])
], -1)
const _hoisted_22 = { class: "columns is-desktop" }
const _hoisted_23 = { class: "column" }
const _hoisted_24 = { class: "my-5" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "CCMS Account", -1)
const _hoisted_26 = {
  class: "subtitle is-6",
  "data-test": "ccmsOptions"
}
const _hoisted_27 = { class: "my-5" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Type", -1)
const _hoisted_29 = {
  class: "subtitle is-6",
  "data-test": "clientType"
}
const _hoisted_30 = { class: "my-5" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Default Redirection URL", -1)
const _hoisted_32 = {
  class: "subtitle is-6",
  "data-test": "defaultRedirect"
}
const _hoisted_33 = { class: "column" }
const _hoisted_34 = { class: "my-5" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "MSAL Cache", -1)
const _hoisted_36 = {
  class: "subtitle is-6",
  "data-test": "downloadMsalCache"
}
const _hoisted_37 = { class: "my-5" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Requires MFA", -1)
const _hoisted_39 = {
  class: "subtitle is-6",
  "data-test": "requiresMfa"
}
const _hoisted_40 = { key: 1 }
const _hoisted_41 = {
  key: 1,
  class: "container is-tp-container",
  "data-test": "not-allowed"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "notification is-danger is-light" }, " You don't have the required permissions to manage applications ", -1)
const _hoisted_43 = [
  _hoisted_42
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadcrumbs = _resolveComponent("breadcrumbs")!
  const _component_redirect_url = _resolveComponent("redirect-url")!
  const _component_identity_form = _resolveComponent("identity-form")!
  const _component_Confirm = _resolveComponent("Confirm")!

  return (_ctx.display)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_breadcrumbs, { data: _ctx.breadcrumbs }, null, 8, ["data"]),
          (_ctx.loadingApp)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6, 512))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (!_ctx.error)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (!_ctx.edit)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                  _createElementVNode("figure", _hoisted_12, [
                                    (_ctx.appDetails.logoSrc!==null)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          class: "is-squircle",
                                          src: _ctx.appDetails.logoSrc,
                                          alt: "Application logo",
                                          "data-test": "application-logo"
                                        }, null, 8, _hoisted_13))
                                      : (_openBlock(), _createElementBlock("div", {
                                          key: 1,
                                          class: "initialApp",
                                          style: _normalizeStyle(`background: ${_ctx.appDetails.hexColor}`),
                                          "data-test": "application-initials"
                                        }, [
                                          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.initials(_ctx.appDetails.name)), 1)
                                        ], 4))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                  _createElementVNode("h1", _hoisted_16, _toDisplayString(_ctx.appDetails.name), 1)
                                ]),
                                (_ctx.allowEdit)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                      _createElementVNode("button", {
                                        class: "button is-success form-buttons mx-3",
                                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.edit=true)),
                                        "data-test": "edit-button"
                                      }, _hoisted_19),
                                      _createElementVNode("button", {
                                        class: _normalizeClass(["button is-danger form-buttons", { 'is-loading': _ctx.loadingDeleteApp }]),
                                        "data-test": "delete-button"
                                      }, [
                                        _createElementVNode("span", {
                                          class: "material-icons",
                                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDeleteModal = true))
                                        }, "delete_forever")
                                      ], 2)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.appDetails.description), 1),
                              _hoisted_21,
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                  _createElementVNode("div", _hoisted_24, [
                                    _hoisted_25,
                                    _createElementVNode("h4", _hoisted_26, _toDisplayString(_ctx.appDetails.ccmsOptions), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_27, [
                                    _hoisted_28,
                                    _createElementVNode("h4", _hoisted_29, _toDisplayString(_ctx.appDetails.clientType), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_30, [
                                    _hoisted_31,
                                    _createElementVNode("h4", _hoisted_32, _toDisplayString(_ctx.appDetails.defaultRedirect), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("div", _hoisted_34, [
                                    _hoisted_35,
                                    _createElementVNode("h4", _hoisted_36, _toDisplayString(_ctx.yesOrNot(_ctx.appDetails.downloadMsalCache)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_37, [
                                    _hoisted_38,
                                    _createElementVNode("h4", _hoisted_39, _toDisplayString(_ctx.yesOrNot(_ctx.appDetails.requiresMfa)), 1)
                                  ])
                                ])
                              ]),
                              _createVNode(_component_redirect_url, {
                                onAddUrl: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addUrl($event))),
                                onDeleteUrl: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteAppUrl($event))),
                                loadingUrl: _ctx.loadingUrl,
                                deletingUrl: _ctx.deletingUrl,
                                applicationUrls: _ctx.appDetails.redirectUrls
                              }, null, 8, ["loadingUrl", "deletingUrl", "applicationUrls"])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            (_ctx.allowEdit)
                              ? (_openBlock(), _createBlock(_component_identity_form, {
                                  key: 0,
                                  loading: _ctx.loadingApp,
                                  newApp: false,
                                  onBack: _ctx.back,
                                  onHandleApp: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editApplicationData($event))),
                                  appDetails: _ctx.appDetails
                                }, null, 8, ["loading", "onBack", "appDetails"]))
                              : _createCommentVNode("", true)
                          ]))
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_41, _hoisted_43))
              ])),
          (_ctx.showDeleteModal)
            ? (_openBlock(), _createBlock(_component_Confirm, {
                key: 2,
                modalClass: 'danger',
                modalIcon: 'error',
                actionIcon: 'delete_forever',
                title: 'Confirm',
                message: 'Are you sure you want to delete this application?',
                onResult: _cache[5] || (_cache[5] = ($event: any) => (_ctx.modalResult($event)))
              }))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}